/**
 *车辆所有人档案相关请求
 */
import request from "@/utils/request";

export interface CarOwnerListRequestParams {
    page: number;
    limit: number;
    name: string;
}

export const carOwnerListRequestPath = '/api/v2/carOwner/list';


// 获取数据
export const carOwnerListRequest = (params: CarOwnerListRequestParams) => {
    return request.get(carOwnerListRequestPath,{
        params
    })
}
